// import React, { Component } from "react";
// import { Link } from "react-router-dom";
// import Credentials, {
//   currentTenant,
//   currentUser,
//   logo,
//   roles,
//   selectedMenu,
//   userid,
// } from "../Common/Credentials";
// import {
//   accounts,
//   appmaster,
//   assetmanagement,
//   inventory,
//   production,
//   purchase,
//   sales,
//   salestravels,
//   screens,
// } from "../Common/Products";
// import { loadTree } from "../Component/MenuTreeHelper";
// import defaultlogo from "../images/no-logo.png";
// import finanzz from "../images/BLUE FEV.png";
// import New360ERP from "../images/360BG.png";
// import SettingsServices from "../Settings/SettingsServices";
// import UsercustomerService from "../Masters/Usercustomers/UsercustomerService";

// import dashboardIcon from "../images/Icons/dashboard.png"
// import activedashboardIcon from "../images/Icons/dashboardactive.png"
// import accountingIcon from "../images/Icons/accounting.png"
// import activeaccountingIcon from "../images/Icons/accountingactive.png"
// import mastersIcon from "../images/Icons/generic.png"
// import activemastersIcon from "../images/Icons/genericactive.png"
// import assetIcon from "../images/Icons/assets.png"
// import activeassetIcon from "../images/Icons/assetsactive.png"
// import inventoryIcon from "../images/Icons/Inventory.png"
// import activeinventoryIcon from "../images/Icons/Inventoryactive.png"
// import salesIcon from "../images/Icons/swipe-card.png"
// import activesalesIcon from "../images/Icons/swipe-cardactive.png"
// import travelInvoicesIcon from "../images/Icons/paper-plane.png"
// import activetravelInvoicesIcon from "../images/Icons/paper-planeactive.png"
// import purchaseIcon from "../images/Icons/buy.png"
// import activepurchaseIcon from "../images/Icons/buyactive.png"
// import productionIcon from "../images/Icons/production.png"
// import activeproductionIcon from "../images/Icons/productionactive.png"
// import projectmanagementIcon from "../images/Icons/PM.png"
// import activeprojectmanagementIcon from "../images/Icons/PM_filled.png"

// import superadminIcon from "../images/Icons/management.png"
// import activesuperadminIcon from "../images/Icons/managementactive.png"
// import settingsIcon from "../images/Icons/setting.png"
// import activesettingsIcon from "../images/Icons/settingactive.png"
// import ExcelReader from "./ExcelReader";

// export default class Menu extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       User: currentUser,
//       show: false,
//       showReports: false,
//       selected: 0,
//       dnrequired: false,
//       usercustomers: false,
//     };

//     // 👁️ Refs for eye pupils
//     this.leftEyeRef = React.createRef();
//     this.rightEyeRef = React.createRef();
//   }

//   componentDidMount() {
//     loadTree();
//     if (logo === undefined) {
//       Credentials.setLogo(defaultlogo);
//     }

//     SettingsServices.GetSettings(currentTenant).then((response) =>
//       this.setState({ dnrequired: response.data.dnreq })
//     );

//     UsercustomerService.GetUserCustomersbyUser(userid).then((res) =>
//       this.setState({
//         usercustomers:
//           res.data === "" || res.data === undefined || res.data === null
//             ? false
//             : true,
//       })
//     );

//     // 🟡 Cursor tracking
//     window.addEventListener("mousemove", this.handleMouseMove);
//   }

//   componentWillUnmount() {
//     window.removeEventListener("mousemove", this.handleMouseMove);
//   }

//   handleMouseMove = (e) => {
//     const moveEye = (eye, box, cursorX, cursorY) => {
//       const centerX = box.left + box.width / 2;
//       const centerY = box.top + box.height / 2;
//       const dx = cursorX - centerX;
//       const dy = cursorY - centerY;
//       const angle = Math.atan2(dy, dx);
//       const radius = 5;
//       const x = radius * Math.cos(angle);
//       const y = radius * Math.sin(angle);
//       eye.style.transform = `translate(${x}px, ${y}px)`;
//     };

//     if (this.leftEyeRef.current && this.rightEyeRef.current) {
//       const leftBox = this.leftEyeRef.current.getBoundingClientRect();
//       const rightBox = this.rightEyeRef.current.getBoundingClientRect();
//       moveEye(this.leftEyeRef.current, leftBox, e.clientX, e.clientY);
//       moveEye(this.rightEyeRef.current, rightBox, e.clientX, e.clientY);
//     }
//   };

//   handleshow = () => {
//     this.setState({ show: !this.state.show, selected: 1, showReports: false });
//   };

//   handleshowReports = () => {
//     this.setState({
//       showReports: !this.state.showReports,
//       selected: 8,
//       show: false,
//     });
//   };




//   render() {
//      const menuItems = [
//     { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard,path: '/dashboard' },
//     { id: 'masters', label: 'Masters', icon: FolderLock, path: '/masters' },
//     { id: 'superadminmasters', label: 'Super Admin', icon: Settings, path: '/superadminmasters' },
//     { id: 'accounts', label: 'Accounts', icon: BookOpen, path: '/accounts' },
//     { id: 'assetmanagement', label: 'Assets Management', icon: Building2, path: '/assetsmanagement' },
//     { id: 'inventory', label: 'Inventory', icon: Package, path: '/inventory' },
//     { id: 'sales', label: 'Sales', icon: BadgePercent, path: '/sales' },
//     { id: 'TourAndTravels', label: 'Tours And Travels', icon: PlaneTakeoff, path: '/toursandtravels' },
//     { id: 'purchase', label: 'Purchase', icon: ShoppingCart, path: '/purchase' },
//     { id: 'production', label: 'Production', icon: Factory, path: '/production' },
//     { id: 'projectmanagement', label: 'Project Management', icon: Briefcase, path: '/projectmanagement' },
//     { id: 'settings', label: 'Settings', icon: Settings, path: '/settings' },
//   ];
//     return (
//       <div style={{ height: "90%", position: "fixed", zIndex: "10" }}>
//         {userid === undefined || currentUser === undefined ? (
//           ""
//         ) : (
//           <aside className="main-sidebar elevation-1">
//             {/* <ExcelReader/> */}
//             <div
//               className="sidebar p-0"
//               style={{ height: "calc(90% - (3.5rem + 1px))" }}
//             >
//               <nav className="mt-2 ml-auto">
//                 <ul
//                   className="nav nav-pills nav-sidebar flex-column"
//                   data-widget="treeview"
//                   role="menu"
//                   data-accordion="true"
//                 >
//                   <li
//                     className={`nav-item active ${selectedMenu === "Home" ? "menuselected" : ""
//                       }`}
//                     onClick={() => this.setState({ selected: 0 })}
//                   >
//                     <Link to="/index" className="text-dark nav-link d-flex">
//                       {/* <i className="text-dark nav-icon1 fas fa-tachometer-alt textColour" /> */}
//                       {selectedMenu === "Home" ?
//                         <img src={activedashboardIcon} alt="d" className="nav-icon1" /> :
//                         <img src={dashboardIcon} alt="d" className="nav-icon1 " />
//                       }
//                       <p className={`cursorPointer ps-1  mt-1 ml-1 text-sm ${selectedMenu === "Home" ? "text-bold" : ""}`} >Dashboard</p>
//                     </Link>
//                   </li>
//                   {/* -------------------Masters Section --------------------------------- */}
//                   {appmaster === "YES" &&
//                     (screens.includes("Admin Masters") ||
//                       screens.includes("Accounts Masters") ||
//                       screens.includes("General Masters") ||
//                       screens.includes("Inventory Masters")) ? (
//                     <li
//                       className={`nav-item active ${selectedMenu === "Masters" ? "menuselected" : ""
//                         }`}
//                     >
//                       <div
//                         className={`nav-link text-dark d-flex`}
//                       // onClick={this.handleshow}
//                       >
//                         <Link
//                           to={{
//                             pathname: "/masters",
//                           }}
//                           state={{ message: "" }}
//                           className="text-dark d-flex"
//                         >
//                           {/* <i className="nav-icon1 fas fas fa-th textColour text-sm" /> */}
//                           {selectedMenu === "Masters" ?
//                             <img src={activemastersIcon} alt="d" className="nav-icon1 tw-scale-110" /> :
//                             <img src={mastersIcon} alt="d" className="nav-icon1" />
//                           }
//                           <p className={`cursorPointer mt-1 ml-1 text-sm ${selectedMenu === "Masters" ? "text-bold" : ""}`}>
//                             Masters
//                           </p>
//                         </Link>
//                       </div>
//                     </li>
//                   ) : (
//                     ""
//                   )}
//                   {/* -------------------End Masters Section --------------------------------- */}

//                   {/* -------------------Tenant Section --------------------------------- */}
//                   {roles === "ROLE_SUPERADMIN" ? (
//                     <li
//                       className={`nav-item has-treeview  ${selectedMenu === "Tenants" ? "menuselected" : ""
//                         }`}
//                       onClick={() =>
//                         this.setState({
//                           selected: 2,
//                           show: false,
//                           showReports: false,
//                         })
//                       }
//                     >
//                       <div className=" nav-link text-dark d-flex">
//                         <Link
//                           to={{
//                             pathname: "/superadminmasters",
//                           }}
//                           state={{ message: "" }}
//                           className="text-dark d-flex"
//                         >
//                           {/* <i className=" nav-icon1 fas fa-table textColour text-sm" /> */}

//                           {selectedMenu === "Tenants" ?
//                             <img src={activesuperadminIcon} alt="d" className="nav-icon1 tw-scale-110" /> :
//                             <img src={superadminIcon} alt="d" className="nav-icon1" />
//                           }

//                           <p className={`cursorPointer ps-1 mt-1 ml-1 text-sm ${selectedMenu === "Tenants" ? "text-bold text-sm" : ""}`}>
//                             Super Admin
//                             {/* <i className=" right fas fa-angle-left" /> */}
//                           </p>
//                         </Link>
//                       </div>
//                     </li>
//                   ) : (
//                     ""
//                   )}
//                   {/* --------------------End Tenant Section ------------------------------ */}

//                   {/* -------------------Accounts Section --------------------------------- */}

//                   {accounts === "YES" &&
//                     (screens.includes("Sub Heads / Groups") ||
//                       screens.includes("Create Ledger") ||
//                       screens.includes("Journal Entry") ||
//                       screens.includes("Salary Entry") ||
//                       screens.includes("Direct Stocks") ||
//                       screens.includes("Accounts Payable") ||
//                       screens.includes("Accounts Receivable") ||
//                       screens.includes("Direct Taxes") ||
//                       screens.includes("Indirect Taxes") ||
//                       screens.includes("Losses Entry") ||
//                       screens.includes("Assets Loses/Expenses") ||
//                       screens.includes("Rectification Entries") ||
//                       screens.includes("Debit Credit Notes") ||
//                       screens.includes("Employees Salary")) ? (
//                     <>
//                       <li
//                         className={`nav-item has-treeview  ${selectedMenu === "Accounts" ? "menuselected" : ""
//                           }`}
//                         onClick={() =>
//                           this.setState({
//                             selected: 3,
//                             show: false,
//                             showReports: false,
//                           })
//                         }
//                       >
//                         <div className="  nav-link text-dark d-flex">
//                           <Link to="/accounts" className="text-dark d-flex">
//                             {/* <i className=" nav-icon1 fas fa-money-bill-alt textColour text-sm" /> */}
//                             {selectedMenu === "Accounts" ?
//                               <img src={activeaccountingIcon} alt="d" className="nav-icon1 tw-scale-120" /> :
//                               <img src={accountingIcon} alt="d" className="nav-icon1" />
//                             }
//                             <p className={`cursorPointer ps-1 mt-1 ml-1 text-sm ${selectedMenu === "Accounts" ? "text-bold" : ""}`}>
//                               Accounts
//                               {/* <i className="right fas fa-angle-left" /> */}
//                             </p>
//                           </Link>
//                         </div>
//                       </li>
//                     </>
//                   ) : (
//                     ""
//                   )}
//                   {/* --------------------End Accounts Section ------------------------------ */}

//                   {/* --------------------Assets Section start------------------------------ */}
//                   {assetmanagement === "YES" &&
//                     (screens.includes("Assets") ||
//                       screens.includes("Maintenance") ||
//                       screens.includes("Production Usage") ||
//                       screens.includes("Production Usage") ||
//                       screens.includes("Transportation")) ? (
//                     <>
//                       <li
//                         className={`nav-item has-treeview  ${selectedMenu === "Assets" ? "menuselected" : ""
//                           }`}
//                         onClick={() =>
//                           this.setState({
//                             selected: 10,
//                             show: false,
//                             showReports: false,
//                           })
//                         }
//                       >
//                         <div className="  nav-link text-dark d-flex">
//                           <Link
//                             to={{
//                               pathname: "/assetmanagement",
//                             }}
//                             state={{
//                               message: "",
//                               sold: false,
//                               rent: false,
//                               active: true,
//                               type: "Rental",
//                               stype: "Sales",
//                             }}
//                             className="text-dark d-flex"
//                           >
//                             {/* <i className=" nav-icon1 fas fa-toolbox textColour text-sm" /> */}

//                             {selectedMenu === "Assets" ?
//                               <img src={activeassetIcon} alt="d" className="nav-icon1 tw-scale-110" /> :
//                               <img src={assetIcon} alt="d" className="nav-icon1" />
//                             }
//                             <p className={`cursorPointer ps-1 mt-1 ml-1 text-sm ${selectedMenu === "Assets" ? "text-bold" : ""}`}>
//                               Assets Management
//                               {/* <i className="right fas fa-angle-left" /> */}
//                             </p>
//                           </Link>
//                         </div>
//                       </li>
//                     </>
//                   ) : (
//                     ""
//                   )}
//                   {/* --------------------Assets Section end------------------------------ */}

//                   {/* -------------------Inventory Section --------------------------------- */}
//                   {inventory === "YES" &&
//                     (screens.includes("Items") ||
//                       screens.includes("Services") ||
//                       screens.includes("Price") ||
//                       screens.includes("Stock") ||
//                       screens.includes("Stock Issue")) ? (
//                     <>
//                       <li
//                         className={`nav-item has-treeview  ${selectedMenu === "Inventory" ? "menuselected" : ""
//                           }`}
//                         onClick={() =>
//                           this.setState({
//                             selected: 4,
//                             show: false,
//                             showReports: false,
//                           })
//                         }
//                       >
//                         <div className="  nav-link text-dark d-flex">
//                           <Link
//                             to={{
//                               pathname: "/inventory",
//                             }}
//                             state={{ message: "" }}
//                             className="text-dark d-flex"
//                           >
//                             {/* <i className=" nav-icon1 fas fa-boxes textColour text-sm" /> */}

//                             {selectedMenu === "Inventory" ?
//                               <img src={activeinventoryIcon} alt="d" className="nav-icon1 tw-scale-110" /> :
//                               <img src={inventoryIcon} alt="d" className="nav-icon1" />
//                             }
//                             <p className={`cursorPointer ps-1 mt-1 ml-1 text-sm ${selectedMenu === "Inventory" ? "text-bold" : ""}`}>
//                               Inventory
//                               {/* <i className="right fas fa-angle-left" /> */}
//                             </p>
//                           </Link>
//                         </div>
//                       </li>
//                     </>
//                   ) : (
//                     ""
//                   )}
//                   {/* ---------------------- End of Inventory Section ----------------- */}

//                   {/* -------------------Sales Section --------------------------------- */}
//                   {sales === "YES" &&
//                     (screens.includes("Sales") ||
//                       screens.includes("Sale Order") ||
//                       screens.includes("Quotation") ||
//                       screens.includes("Invoice") ||
//                       screens.includes("Delivery/Shipment Note") ||
//                       screens.includes("Sales Returns") ||
//                       screens.includes("Receipts") ||
//                       screens.includes("Debit Note") ||
//                       screens.includes("Point of Sale") ||
//                       screens.includes("Stock Acceptance") ||
//                       screens.includes("Pos Price Master") ||
//                       screens.includes("Direct Trade")) ? (
//                     <>
//                       <li
//                         className={`nav-item has-treeview  ${selectedMenu === "Sales" ? "menuselected" : ""
//                           }`}
//                         onClick={() =>
//                           this.setState({
//                             selected: 5,
//                             show: false,
//                             showReports: false,
//                           })
//                         }
//                       >
//                         <div className="  nav-link text-dark d-flex">
//                           <Link
//                             to={{
//                               pathname: "/sales",
//                             }}
//                             state={{ message: "" }}
//                             className="text-dark d-flex"
//                           >
//                             {/* <i className=" nav-icon1 fab fa-opencart textColour text-sm" /> */}
//                             {selectedMenu === "Sales" ?
//                               <img src={activesalesIcon} alt="d" className="nav-icon1 tw-scale-110" /> :
//                               <img src={salesIcon} alt="d" className="nav-icon1" />
//                             }
//                             <p className={`cursorPointer ps-1 mt-1 ml-1 text-sm ${selectedMenu === "Sales" ? "text-bold" : ""}`}>
//                               Sales
//                               {/* <i className="right fas fa-angle-left" /> */}
//                             </p>
//                           </Link>
//                         </div>
//                       </li>
//                     </>
//                   ) : (
//                     ""
//                   )}
//                   {/*--------------------End of Sales Section -----------------------*/}

//                   {/* ----------------------------------------------------------------------START TOURS & TRAVELLERS STARTS -------------------------------------------------- */}

//                   {salestravels === "YES" ?
//                     <li
//                       className={`nav-item has-treeview  ${selectedMenu === "Salestravel" ? "menuselected" : ""
//                         }`}
//                       onClick={() =>
//                         this.setState({
//                           selected: 9,
//                           show: false,
//                           showReports: false,
//                         })
//                       }
//                     >
//                       {/* <div className=" nav-link text-dark d-flex">
//                         <Link
//                           to={{
//                             pathname: "/salestravelinvoice",
//                           }}
//                           state={{ message: "" }}
//                           className="text-dark d-flex"
//                         >
//                           {selectedMenu === "Salestravel" ?
//                             <img src={activetravelInvoicesIcon} alt="d" className="nav-icon1 tw-scale-110" /> :
//                             <img src={travelInvoicesIcon} alt="d" className="nav-icon1" />
//                           }
//                           <p className={`cursorPointer ps-1 mt-1 ml-1 text-sm ${selectedMenu === "Salestravel" ? "text-bold" : ""}`}>Sales Travel </p>
//                         </Link>
//                       </div> */}
//                       <div className=" nav-link text-dark d-flex">
//                         {/* <i className=" nav-icon1 fa fa-plane textColour text-sm" /> */}
//                         <Link
//                           to={{
//                             pathname: "/TourAndTravels",
//                           }}
//                           state={{ message: "" }}
//                           className="text-dark d-flex"
//                         >
//                           {selectedMenu === "toursandtravels" ?
//                             <img src={activetravelInvoicesIcon} alt="d" className="nav-icon1 tw-scale-110" /> :
//                             <img src={travelInvoicesIcon} alt="d" className="nav-icon1" />
//                           }
//                           <p className={`cursorPointer ps-1 mt-1 ml-1 text-sm ${selectedMenu === "Salestravel" ? "text-bold" : ""}`}>Tours And Travels</p>
//                         </Link>
//                       </div>
//                     </li> : ""}
//                   {/* -----------------------------------End of Direct Trade -------------------- */}

//                   {/* --------------------Purchase Section ------------------------------ */}
//                   {purchase === "YES" &&
//                     (screens.includes("Purchase") ||
//                       screens.includes("Purchase Returns") ||
//                       screens.includes("GRN") ||
//                       screens.includes("SCN") ||
//                       screens.includes("Bill of Entry") ||
//                       screens.includes("Credit Note")) ? (
//                     <>
//                       <li
//                         className={`nav-item has-treeview  ${selectedMenu === "Purchase" ? "menuselected" : ""
//                           }`}
//                         onClick={() =>
//                           this.setState({
//                             selected: 7,
//                             show: false,
//                             showReports: false,
//                           })
//                         }
//                       >
//                         <div className="  nav-link text-dark d-flex">
//                           <Link
//                             to={{
//                               pathname: "/purchase",
//                             }}
//                             state={{ message: "" }}
//                             className="text-dark d-flex"
//                           >
//                             {/* <i className=" nav-icon1 fas fa-cart-arrow-down textColour text-sm" /> */}
//                             {selectedMenu === "Purchase" ?
//                               <img src={activepurchaseIcon} alt="d" className="nav-icon1 tw-scale-110" /> :
//                               <img src={purchaseIcon} alt="d" className="nav-icon1" />
//                             }
//                             <p className={`cursorPointer ps-1 mt-1 ml-1 text-sm ${selectedMenu === "Purchase" ? "text-bold" : ""}`}>
//                               Purchase
//                               {/* <i className="right fas fa-angle-left" /> */}
//                             </p>
//                           </Link>
//                         </div>
//                       </li>
//                     </>
//                   ) : (
//                     ""
//                   )}
//                   {/* -------------------------- End of Purchase Section-------------------*/}

//                   {/* ---------------------------Production------------------------------- */}
//                   {production === "YES" &&
//                     (screens.includes("Estimation") ||
//                       screens.includes("Job Order") ||
//                       screens.includes("Indenting") ||
//                       screens.includes("InProcess") ||
//                       screens.includes("Quality Analysis") ||
//                       screens.includes("Store") ||
//                       screens.includes("Immediate Production")) ? (
//                     <>
//                       <li
//                         className={`nav-item has-treeview  ${selectedMenu === "Production" ? "menuselected" : ""
//                           }`}
//                         onClick={() =>
//                           this.setState({
//                             selected: 9,
//                             show: false,
//                             showReports: false,
//                           })
//                         }
//                       >
//                         <div className=" nav-link text-dark d-flex">
//                           <Link
//                             to={{
//                               pathname: "/production",
//                             }}
//                             state={{ message: "" }}
//                             className="text-dark d-flex"
//                           >
//                             {/* <i className=" nav-icon1 fa fa-industry textColour text-sm" /> */}
//                             {selectedMenu === "Production" ?
//                               <img src={activeproductionIcon} alt="d" className="nav-icon1 tw-scale-110" /> :
//                               <img src={productionIcon} alt="d" className="nav-icon1" />
//                             }
//                             <p className={`cursorPointer ps-1 mt-1 ml-1 text-sm ${selectedMenu === "Production" ? "text-bold" : ""}`}>Production</p>
//                           </Link>
//                         </div>
//                       </li>
//                     </>
//                   ) : (
//                     ""
//                   )}
//                   {/* ----------------------------End of Production----------------------- */}

//                   {/* ----------------------Project Management------------------------- */}
//                   {production === "YES" && <li
//                     className={`nav-item has-treeview  ${selectedMenu === "Project Management" ? "menuselected" : ""
//                       }`}
//                     onClick={() =>
//                       this.setState({
//                         selected: 9,
//                         show: false,
//                         showReports: false,
//                       })
//                     }
//                   >
//                     <div className=" nav-link text-dark d-flex">
//                       <Link
//                         to={{
//                           pathname: "/projectmanagement",
//                         }}
//                         state={{ message: "" }}
//                         className="text-dark d-flex"
//                       >
//                         {selectedMenu === "Project Management" ?
//                           <img src={activeprojectmanagementIcon} alt="d" className="nav-icon1 tw-scale-110" /> :
//                           <img src={projectmanagementIcon} alt="d" className="nav-icon1" />
//                         }
//                         <p className={`cursorPointer ps-1 mt-1 ml-1 text-sm ${selectedMenu === "Project Management" ? "text-bold" : ""}`}>Project Management</p>
//                       </Link>
//                     </div>
//                   </li>}
//                   {/* -------------------- End of Project Management -------------------- */}
//                   {/* ---------------------Settings------------------ */}

//                   <li
//                     className={`nav-item has-treeview  ${selectedMenu === "Settings" ? "menuselected" : ""
//                       }`}
//                   >
//                     <div className=" nav-link text-dark d-flex">
//                       <Link
//                         to={{
//                           pathname: "/settings",
//                         }}
//                         state={{ message: "" }}
//                         className="text-dark d-flex"
//                       >
//                         {selectedMenu === "Settings" ?
//                           <img src={activesettingsIcon} alt="d" className="nav-icon1 tw-scale-110" /> :
//                           <img src={settingsIcon} alt="d" className="nav-icon1" />
//                         }
//                         <p className={`cursorPointer ps-1 mt-1 ml-1 text-sm ${selectedMenu === "Settings" ? "text-bold" : ""}`}>Settings</p>
//                       </Link>
//                     </div>
//                   </li>


//                   {/* ---------------------End of Settings------------------ */}


//                   {/* ---------------------Settings------------------ */}

//                 </ul>
//               </nav>
//               {/* /.sidebar-menu */}
//             </div>
//             {/* /.sidebar */}
//             <div style={{ display: "flex", justifyContent: "center" }}>
//               <img
//                 src={process.env.REACT_APP_FINANZZ_URL === "360" ? New360ERP : finanzz}
//                 alt="Logo..."
//                 className="finanzzlogo"
//               />

//             </div>

//           </aside>
//         )}
//       </div>
//     );
//   }
// }



import React, { useEffect, useRef, useState } from 'react';
import {
  LayoutDashboard,
  Settings,
  Package,
  FolderLock,
  BookOpen,
  Building2,
  BadgePercent,
  PlaneTakeoff,
  ShoppingCart,
  Factory,
  Briefcase,
  ChevronLeft,
  ChevronRight,
  Sparkles,
  User,
  LogOut
} from 'lucide-react';
import Credentials, { selectedMenu, roles, theme } from '../Common/Credentials';
import { useNavigate } from 'react-router-dom';

import {
  accounts,
  appmaster,
  assetmanagement,
  inventory,
  production,
  purchase,
  sales,
  salestravels,
  screens,
} from "../Common/Products";

const hasAnyScreen = (permissions = []) => {
  return permissions.some((permission) =>
    screens.includes(permission)
  );
};



export default function Sidebar() {
  const navigate = useNavigate()
  const [collapsed, setCollapsed] = useState(false);
  const hoverExpandTimer = useRef(null);

  // The header hamburger collapses the sidebar via AdminLTE (body.sidebar-collapse),
  // not via this component's state - sync so the callout swaps to its icon form.
  useEffect(() => {
    const sync = () =>
      setCollapsed(document.body.classList.contains("sidebar-collapse"));
    sync();
    const obs = new MutationObserver(sync);
    obs.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    return () => obs.disconnect();
  }, []);

  const [hoverExpand, setHoverExpand] = useState(false);

  // Hovering the collapsed rail temporarily expands the whole sidebar,
  // revealing labels and the full Upgrade card. Collapse again on leave.
  const railCollapsed = collapsed && !hoverExpand;

  const handleRailEnter = () => {
    if (!collapsed) return;
    if (hoverExpandTimer.current) clearTimeout(hoverExpandTimer.current);
    hoverExpandTimer.current = setTimeout(() => setHoverExpand(true), 150);
  };

  const handleRailLeave = () => {
    if (hoverExpandTimer.current) {
      clearTimeout(hoverExpandTimer.current);
      hoverExpandTimer.current = null;
    }
    setHoverExpand(false);
  };
  const activeTab = selectedMenu || 'dashboard'
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, path: '/dashboard', visible: true, },
    { id: 'masters', label: 'Masters', icon: FolderLock, path: '/masters', visible: appmaster === "YES" && hasAnyScreen(["Admin Masters", "Accounts Masters", "General Masters", "Inventory Masters",]), },
    { id: 'superadminmasters', label: 'Super Admin', icon: Settings, path: '/superadminmasters', visible: roles === "ROLE_SUPERADMIN", },
    { id: 'accounts', label: 'Accounts', icon: BookOpen, path: '/accounts', visible: accounts === "YES" && hasAnyScreen(["Sub Heads / Groups", "Create Ledger", "Journal Entry", "Salary Entry", "Direct Stocks", "Accounts Payable", "Accounts Receivable", "Direct Taxes", "Indirect Taxes", "Losses Entry", "Assets Loses/Expenses", "Rectification Entries", "Debit Credit Notes", "Employees Salary"]) },
    { id: 'assetmanagement', label: 'Assets Management', icon: Building2, path: '/assetsmanagement', visible: assetmanagement === "YES" && hasAnyScreen(["Assets", "Maintenance", "Production Usage", "Transportation",]) },
    { id: 'inventory', label: 'Inventory', icon: Package, path: '/inventory', visible: inventory === "YES" && hasAnyScreen(["Items", "Services", "Price", "Stock", "Stock Issue"]) },
    { id: 'sales', label: 'Sales', icon: BadgePercent, path: '/sales', visible: sales === "YES" && hasAnyScreen(["Sales", "Sale Order", "Quotation", "Invoice", "Delivery/Shipment Note", "Sales Returns", "Receipts", "Debit Note", "Point of Sale", "Stock Acceptance", "Pos Price Master", "Direct Trade"]), },
    { id: 'TourAndTravels', label: 'Tours And Travels', icon: PlaneTakeoff, path: '/toursandtravels', visible: salestravels === "YES" },
    { id: 'purchase', label: 'Purchase', icon: ShoppingCart, path: '/purchase', visible: purchase === "YES" && hasAnyScreen(["Purchase", "Purchase Returns", "GRN", "SCN", "Bill of Entry", "Credit Note"]) },
    { id: 'production', label: 'Production', icon: Factory, path: '/production', visible: production === "YES" && hasAnyScreen(["Estimation", "Job Order", "Indenting", "InProcess", "Quality Analysis", "Store", "Immediate Production"]) },
    { id: 'projectmanagement', label: 'Project Management', icon: Briefcase, path: '/projectmanagement', visible: production === "YES" },
    { id: 'settings', label: 'Settings', icon: Settings, path: '/settings', visible: true, },
  ];

  const handleTabChange = (tabId) => {
    Credentials.setSelectedMenu(tabId)
    navigate(`/${tabId}`);
  }

  return (
    <div style={{ height: "90%", position: "fixed", zIndex: "10" }}>
      <div
        id="sidebar-container"
        onMouseEnter={handleRailEnter} onMouseLeave={handleRailLeave} className={`main-sidebar tw-bg-white tw-text-slate-700 tw-flex tw-flex-col tw-transition-all tw-duration-300 tw-border-r tw-rounded-lg tw-border-slate-200/80 !tw-shadow-[0_8px_30px_rgba(0,0,0,0.015)] ${railCollapsed ? 'tw-w-20' : 'tw-w-64'}`}
      >
        {/* Sidebar Header Brand Area */}
        {/* <div id="sidebar-header" className="tw-p-6 tw-flex tw-items-center tw-justify-between tw-border-b tw-border-slate-100">
        <div className="tw-flex tw-items-center tw-gap-3 tw-overflow-hidden">
          <div className="tw-w-10 tw-h-10 tw-shrink-0 tw-bg-blue-500 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-shadow-lg tw-shadow-blue-500/20">
            <svg viewBox="0 0 24 24" className="tw-w-6 tw-h-6 tw-text-white tw-fill-current">
              <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm1-3.15V4h-2V-1.15h2zM12 20a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-15a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm-3.5 5.5a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zm7 0a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5z" />
            </svg>
          </div>

          {!railCollapsed && (
            <div className="tw-flex tw-flex-col tw-text-left">
              <span className="tw-font-extrabold tw-tracking-tight tw-text-slate-900 tw-text-base">
                Jnana Technologies
              </span>
              <span className="tw-text-[10px] tw-text-slate-500 tw-font-medium">
                Financial Year: 2026-2027
              </span>
            </div>
          )}
        </div>

        <button 
          id="sidebar-toggle-btn"
          onClick={() => setCollapsed(!collapsed)}
          className="tw-absolute tw--right-3.5 tw-top-6 tw-bg-blue-500 hover:tw-bg-blue-600 tw-text-white tw-w-7 tw-h-7 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-border tw-border-white tw-shadow-md tw-cursor-pointer tw-z-20"
        >
          {collapsed ? <ChevronRight size={14} /> : <ChevronLeft size={14} />}
        </button>
      </div> */}

        {/* Main Navigation Scroll Area */}
        <div
          id="sidebar-nav-scroll"
          className="tw-flex-1 tw-overflow-y-auto tw-p-2 tw-space-y-1 scrollbar-thin scrollbar-thumb-slate-200"
        >
          {menuItems.map((item) => {
            const IconComponent = item.icon;
            const isActive = activeTab === item.id;

            return item.visible && (
              <button
                id={`nav-item-${item.id}`}
                key={item.id}
                onClick={() => { handleTabChange(item.id) }}
                className={`tw-w-full tw-flex tw-items-center tw-gap-3.5 tw-px-4 tw-py-3 tw-rounded-xl tw-text-sm tw-font-medium tw-transition-all tw-group tw-relative tw-cursor-pointer ${isActive
                  ? theme === "classic" ? 'tw-bg-[#4d4d4d] tw-text-white tw-shadow-md tw-shadow-blue-600/10' : 'tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600 tw-text-white tw-shadow-md tw-shadow-blue-600/10'
                  : 'hover:tw-bg-slate-100 hover:tw-text-slate-900 tw-text-slate-500'
                  }`}
              >
                <IconComponent
                  size={18}
                  className={`tw-shrink-0 tw-transition-transform ${isActive ? 'tw-scale-110' : 'group-hover:tw-scale-105'
                    }`}
                />

                <span className={`tw-whitespace-nowrap tw-overflow-hidden tw-transition-all tw-duration-150 ${railCollapsed ? "tw-max-w-0 tw-opacity-0" : "tw-max-w-44 tw-opacity-100"}`}>{item.label}</span>

                {/* Tooltip for collapsed status */}
                {railCollapsed && (
                  <div className="tw-absolute tw-left-20 tw-bg-slate-900 tw-text-white tw-text-xs tw-px-3 tw-py-1.5 tw-rounded-md tw-opacity-0 group-hover:tw-opacity-100 tw-pointer-events-none tw-transition-opacity tw-font-medium tw-z-50 tw-whitespace-nowrap tw-shadow-xl tw-border tw-border-slate-850">
                    {item.label}
                  </div>
                )}
              </button>
            );
          })}
        </div>

        {/* Sidebar Footer Callout - both branches stay mounted and cross-fade
            with the sidebar width animation instead of swapping instantly */}
        <div
          id="sidebar-premium-callout-wrap"
          className={`tw-overflow-hidden tw-transition-all tw-duration-300 ${railCollapsed ? "tw-max-h-0 tw-opacity-0" : "tw-max-h-72 tw-opacity-100"}`}
        >
          <div
            id="sidebar-premium-callout"
            className={(theme === "classic" ? ' tw-bg-[#fcfafd] tw-border-[#4d4d4d]/50' : ' tw-bg-gradient-to-b tw-from-blue-50 tw-to-indigo-50/60 tw-border-blue-100/50') + " tw-p-4 tw-m-4 tw-max-w-full tw-rounded-2xl tw-border tw-flex tw-flex-col tw-gap-3"}
          >
            <div className="tw-flex tw-items-center tw-gap-2">
              <div className="tw-w-8 tw-h-8 tw-rounded-lg tw-bg-pink-100 tw-flex tw-items-center tw-justify-center tw-text-pink-600 tw-shadow-inner">
                <Sparkles size={16} />
              </div>

              <div className="tw-flex tw-flex-col tw-text-left tw-overflow-hidden">
                <span className="tw-text-xs tw-font-bold tw-text-slate-900 tw-whitespace-nowrap">
                  Upgrade to Premium
                </span>

                <span className="tw-text-[10px] tw-text-slate-500 tw-whitespace-nowrap">
                  Unlock custom metrics & storage.
                </span>
              </div>
            </div>

            <button
              id="sidebar-upgrade-btn"
              // onClick={() => setShowUpgradeModal(true)}
              className={`${theme === "classic" ? 'tw-bg-[#4d4d4d] tw-text-white tw-text-xs tw-font-semibold tw-py-2.5 tw-px-4 tw-rounded-xl tw-transition-all tw-shadow-md tw-shadow-blue-600/10 hover:tw-shadow-blue-600/20 tw-cursor-pointer' : 'tw-w-full tw-bg-blue-600 hover:tw-bg-blue-500 active:tw-bg-blue-700 tw-text-white tw-text-xs tw-font-semibold tw-py-2.5 tw-px-4 tw-rounded-xl tw-transition-all tw-shadow-md tw-shadow-blue-600/10 hover:tw-shadow-blue-600/20 tw-cursor-pointer'} tw-whitespace-nowrap tw-overflow-hidden`}
            >
              Upgrade Now →
            </button>
          </div>
        </div>
        <div
          id="sidebar-upgrade-collapsed-wrap"
          className={`tw-flex tw-justify-center tw-border-t tw-border-slate-100 tw-overflow-hidden tw-transition-all tw-duration-300 ${railCollapsed ? "tw-max-h-20 tw-opacity-100 tw-p-4" : "tw-max-h-0 tw-opacity-0 tw-p-0 tw-border-transparent"}`}
        >
          <button
            id="sidebar-upgrade-collapsed"
            // onClick={() => setShowUpgradeModal(true)}
            className="tw-w-10 tw-h-10 tw-rounded-xl tw-bg-gradient-to-r tw-from-pink-500 tw-to-indigo-500 tw-flex tw-items-center tw-justify-center tw-text-white tw-shadow-md hover:tw-scale-105 tw-transition-transform tw-cursor-pointer tw-shrink-0"
          >
            <Sparkles size={16} />
          </button>
        </div>
      </div>
    </div >
  );
}